export default "__VITE_ASSET__596531a8__"